const getCookieValue = (cookie_name) => {
    if (typeof document !== `undefined`) {
        const cookie_value = document.cookie.match(
            `(^|[^;]+)\\s*${cookie_name}\\s*=\\s*([^;]+)`
        )
        
        return cookie_value ? cookie_value.pop() : ''
    }
}

export default getCookieValue
